// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__133BI","productName":"Table_productName__UuTor"};